import { getAdminOrderDetail } from "@/api/order";
import { useApi } from "@/hooks";

export default {
  state: {
    detail: null
  },
  mutations: {
    setDetail(state, detail) {
      state.detail = detail;
    }
  },
  actions: {
    fetchOrderDetail({ commit }, { id, afterFetch }) {
      useApi(
        getAdminOrderDetail({ id }).then(res => {
          commit("setDetail", res);
          if (afterFetch) afterFetch();
        })
      );
    }
  }
};
